export default __webpack_public_path__ + "static/media/reference.6c1ef0a9.svg";